export function normalizePhone(value) {
  if (!value) return '';
  let s = String(value).trim();
  // remove spaces, dashes, parentheses
  s = s.replace(/[\s\-()]+/g, '');
  // remove leading '+'
  if (s.startsWith('+')) s = s.slice(1);
  // remove leading '00'
  if (s.startsWith('00')) s = s.slice(2);
  // keep digits only
  let digits = s.replace(/\D/g, '');
  // TR heuristics
  if (digits.length === 12 && digits.startsWith('90')) return digits;
  if (digits.length === 11 && digits.startsWith('0') && digits[1] === '5') return '90' + digits.slice(1);
  if (digits.length === 10 && digits.startsWith('5')) return '90' + digits;
  if (digits.startsWith('0090')) return '90' + digits.slice(4);
  return digits;
}

